
<template>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="#151515" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.33398 5.41667C3.74063 5.41667 3.25065 5.90664 3.25065 6.5V19.5C3.25065 20.0934 3.74063 20.5833 4.33398 20.5833H21.6673C22.2607 20.5833 22.7506 20.0934 22.7506 19.5V6.5C22.7506 5.90664 22.2607 5.41667 21.6673 5.41667H4.33398ZM1.08398 6.5C1.08398 4.71002 2.54401 3.25 4.33398 3.25H21.6673C23.4573 3.25 24.9173 4.71002 24.9173 6.5V19.5C24.9173 21.29 23.4573 22.75 21.6673 22.75H4.33398C2.54401 22.75 1.08398 21.29 1.08398 19.5V6.5Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.27991 5.88014C1.62302 5.38999 2.29851 5.27079 2.78866 5.61389L13.0007 12.7624L23.2128 5.61389C23.703 5.27079 24.3785 5.38999 24.7216 5.88014C25.0647 6.3703 24.9455 7.04579 24.4553 7.3889L13.622 14.9722C13.249 15.2333 12.7525 15.2333 12.3795 14.9722L1.54616 7.3889C1.05601 7.04579 0.936802 6.3703 1.27991 5.88014Z"
        />
    </svg>
</template>
<script>
export default {
    name: "PublicLetterIcon"
}
</script>
